// PubNub settings will be moved into this file later
import Vue from "vue";
import Pubnub from "pubnub";
import EventBus from "@/lib/utilities/eventBus.js";
import { NotificationType } from "@/lib/utilities/enums";
import { convertIdToPubNubKind } from "@/lib/utilities/index";

function getPubnubListener(context) {
  return {
    status: function (statusEvent) {
      /*
          PNNetworkUpCategory         SDK detected that network is online.
          PNConnectedCategory         SDK subscribed with a new mix of channels (fired every time the channel / channel group mix changed).
          PNReconnectedCategory       SDK was able to reconnect to pubnub.
          PNNetworkDownCategory       SDK detected that network is down.
          PNNetworkIssuesCategory     A subscribe event experienced an exception when running.
          PNTimeoutCategory           Failure to establish connection due to timeout.
          PNAccessDeniedCategory      PAM permission failure.
          PNMalformedResponseCategory JSON parsing crashed.
          PNBadRequestCategory        Server rejected the request.
          PNDecryptionErrorCategory   If using decryption strategies and the decryption fails.
        */

      switch (statusEvent.category) {
        case "PNNetworkUpCategory":
          console.log("----- Pando: Network Online -----");
          context.commit("updatePubnubConnectionStatus", true);
          // context.dispatch("refreshPubNub");
          break;
        case "PNConnectedCategory":
        case "PNReconnectedCategory":
          console.log("----- Pando: Connection Established -----");
          context.commit("updatePubnubConnectionStatus", true);
          break;
        case "PNNetworkDownCategory":
        case "PNNetworkIssuesCategory":
        case "PNTimeoutCategory":
        case "PNNetworkDown":
        case "PNTLSConnectionFailedCategory":
          console.log("----- Pando: Network Offline -----");
          context.commit("updatePubnubConnectionStatus", false);
          break;
        case "PNAccessDeniedCategory":
          console.log(`----- Pando: Access Denied -----`);
          console.log(JSON.stringify(statusEvent));
          break;
        case "PNMalformedResponseCategory":
          console.log(`----- Pando: Malformed Response -----`);
          console.log(JSON.stringify(statusEvent));
          break;
        case "PNBadRequestCategory":
          console.log(`----- Pando: Bad Request -----`);
          console.log(JSON.stringify(statusEvent));
          break;
        case "PNDecryptionErrorCategory":
          console.log(`----- Pando: Decryption Failed -----`);
          console.log(JSON.stringify(statusEvent));
          break;
        case "PNUnknownCategory":
        default:
          console.log(`----- Pando: Unknown Error -----`);
          console.log(JSON.stringify(statusEvent));
      }
    },
    message: function (message) {
      context.dispatch("handlePubnubNotification", message);
    },
    presence: function (presenceEvent) { }
  };
}

const state = {
  vendorInfo: null,
  pubnubInstance: null,
  isConnectedToPubnub: false
};

const getters = {};

const actions = {
  setupPubNub(context) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/message/vendor")
        .then(resp => {
          if (resp.data && resp.data.Data) {
            context.commit("gotVendorInfo", resp.data.Data);
            context.commit("initializePubNubService", {
              UserId: context.getters.User.UserId,
              Listener: getPubnubListener(context)
            });
          }
        })
        .catch(resp => { });
    });
  },
  handlePubnubNotification(context, pubnubPayload) {
    try {
      if (typeof pubnubPayload != "object")
        pubnubPayload = JSON.parse(pubnubPayload);

      // For debugging purposes only
      // console.log("-------------------------------------------");
      // console.log(pubnubPayload.message.rtid);
      // console.log(pubnubPayload);

      if (
        !pubnubPayload ||
        !pubnubPayload.message ||
        !pubnubPayload.message.rtid ||
        !pubnubPayload.message.msg
      )
        return;
      let message = pubnubPayload.message;

      var notificationType = message.rtid * 1; // AWS Kinesis sends this as string
      var notification = message.msg;

      EventBus.$emit("sendNotificationToGlobalFrame", message);

      switch (notificationType) {
        case NotificationType.AccountUserInfoMessage:
        case NotificationType.UserInfoMessage:
          if (!notification.Id && notification.UserId)
            notification.Id = notification.UserId;
          else if (notification.Id && !notification.UserId)
            notification.UserId = notification.Id;
          context.dispatch("userUpdated", notification);
          break;
        case NotificationType.UserFavoriteMessage:
          if (!notification.Id && notification.UserId)
            notification.Id = notification.UserId;
          else if (notification.Id && !notification.UserId)
            notification.UserId = notification.Id;
          context.dispatch("handleUserFavoriteResponse", notification);
          break;
        case NotificationType.ApiResponseMessage:
          context.dispatch("handleApiResponseMessage", message);
          break;
        case NotificationType.UserCustomNotification:
          context.dispatch("handleUserCustomNotification", notification);
          break;
      }
    } catch (err) {
      console.log("Error handling PubNub notification: ", err);
      console.log("PubNub notification: ", pubnubPayload);
    }
  }
};

const mutations = {
  gotVendorInfo(state, data) {
    state.vendorInfo = data;
  },
  updatePubnubConnectionStatus(state, val) {
    state.isConnectedToPubnub = val;
  },
  initializePubNubService(state, data) {
    let userId = data.UserId;
    let pubnubListener = data.Listener;
    let val = convertIdToPubNubKind(userId);

    // Initialize PubNub instance
    let pubnub = new Pubnub({
      subscribeKey: state.vendorInfo.SubscriptionKey,
      authKey: state.vendorInfo.AuthorizationKey,
      userId: val,
      //uuid: val,
      ssl: true,
      restore: true,
      autoNetworkDetection: true,
      // heartbeatInterval: 30,
      // keepAlive: true,
      // keepAliveSettings: {
      //   keepAliveMsecs: 15000,
      //   maxSockets: 100,
      //   timeout: 0
      // }
    });

    // Subscribe to channels and channel groups
    pubnub.subscribe({
      channels: state.vendorInfo.Channels,
      // withPresence: true,
      channelGroups: state.vendorInfo.ChannelGroups,
      message: function (message, envelope, channelOrGroup, time, channel) {
        console.log(
          "Message Received." +
          "\n" +
          "Channel or Group : " +
          JSON.stringify(channelOrGroup) +
          "\n" +
          "Channel : " +
          JSON.stringify(channel) +
          "\n" +
          "Message : " +
          JSON.stringify(message) +
          "\n" +
          "Time : " +
          time +
          "\n" +
          "Raw Envelope : " +
          JSON.stringify(envelope)
        );
      },
      error: function (error) {
        // Subscription error block
        console.log("pubnub subscribe error: ", error);
      }
    });

    // Add listeners to status events
    pubnub.addListener(pubnubListener);

    state.pubnubInstance = pubnub;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/PubNub.js